module.exports = __webpack_public_path__ + "static/media/27OCHA14.3ad69ad0.jpg";